export default "__VITE_ASSET__dd387294__"